module.exports = __webpack_public_path__ + "img/_DSC7941-min.f3ae66bf.jpg";